const INSTALL = Object.freeze({
  value: '1500',
  unit: 'AL'
})
const MODEM = Object.freeze({
  value: '0',
  unit: 'AL'
})

export { INSTALL, MODEM }
